import CalendarIconSvg from 'assets/images/icons/calendar.svg?react';
import StackIconSvg from 'assets/images/icons/stack.svg?react';
import GuestExpIconSvg from 'assets/images/icons/guest-exp.svg?react';
import CheckInIconSvg from 'assets/images/icons/house-check.svg?react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { PropertyBusinessType } from 'models/Properties';
import usePropertyGuidebookLink from '../usePropertyGuidebookLink';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import AddUnitTypeButton from '../common/header/AddUnitTypeButton';
import HeaderIconButton from '../common/header/HeaderIconButton';
import { HeaderContainer } from '../common/header/CommonHeader.styles';

const PropertySettingsMainTabHeader = () => {
  const { t } = useTranslation();
  const { uid: propertyUid } = useParams();
  const guidebookLink = usePropertyGuidebookLink(propertyUid!);
  const { property } = usePropertySettingsInitData();

  const isHotel = property?.businessType === PropertyBusinessType.HOTEL;
  const isUnitType = property?.businessType === PropertyBusinessType.UNIT_TYPE;

  return (
    <HeaderContainer>
      {!isUnitType && (
        <HeaderIconButton
          id="custom-data-link"
          text={t('pageProperty.mainSettings.header.customData')}
          href={`/l/customDataField_edit.jsp?uid=${propertyUid}`}
          icon={<StackIconSvg />}
        />
      )}

      <HeaderIconButton
        id="calendar-link"
        text={t('pageProperty.mainSettings.header.calendar')}
        href={`/calendar?propertyUid=${propertyUid}`}
        icon={<CalendarIconSvg />}
      />

      {guidebookLink && (
        <HeaderIconButton
          id="guest-experience-link"
          text={t('pageProperty.mainSettings.header.guestExperience')}
          href={guidebookLink}
          icon={<GuestExpIconSvg />}
        />
      )}

      <HeaderIconButton
        id="check-in-instructions-link"
        text={t('pageProperty.mainSettings.header.checkInInstructions')}
        href={`/check-in-instructions?uid=${propertyUid}`}
        icon={<CheckInIconSvg />}
      />

      {isHotel && <AddUnitTypeButton />}
    </HeaderContainer>
  );
};

export default PropertySettingsMainTabHeader;
